// oxlint-disable jsx-no-literals
import { Link } from "react-router";

import { Card } from "@/components/Card";
import { ContentFull, ContentLayout } from "@/components/ContentLayout";
import { FullScreenLayout } from "@/components/FullScreenLayout";

export function PrivacyPolicyPage() {
  return (
    <FullScreenLayout>
      <ContentLayout wet title={<Link to="/privacy-policy">Privacy Policy</Link>}>
        <ContentFull className="pt-26">
          <Card>
            <article className="flex flex-col gap-4 p-4">
              <h1 className="font-title">Privacy policy</h1>

              <p>
                This policy (the &quot;Privacy Policy&quot;) describes the information gathering practices of Bale, in
                the use of the Bale website (our &quot;Website&quot;) and mobile application (our &quot;App&quot;), and
                the services they provide (together the &quot;Services&quot;). By using the Services, you are consenting
                to the Privacy Policy and the collection of any personal information outlined herein.
              </p>

              <p>
                We may update the Privacy Policy from time to time and you are responsible for periodically reviewing
                the most current version of the Privacy Policy on our Website. Your continued use of the Services or
                submission of information will be deemed your conclusive acceptance of our updated Privacy Policy.
              </p>

              <h2 className="font-subtitle">Collecting Using and Disclosing Information</h2>

              <p>
                This Privacy Policy describes our policies regarding the collection, use, and disclosure of the personal
                information that we collect about you through the Services such as your name, and email address. We may
                collect this information when you subscribe to, or sign up for, certain tools or features that we
                provide, when you fill out forms made available through the Services, when you email us with general
                inquiries or with your comments or suggestions, or otherwise in connection with your use of the
                Services. We will limit the personal information we collect to what we need for the purposes for which
                it was collected, and will use such personal information for such purposes. If we wish to use your
                personal information for any other purpose, we will obtain your consent before using the information.
              </p>

              <h2 className="font-subtitle">What Information We Collect</h2>

              <p>
                We collect your email address to enable you to sign up for the Services. Your email is used to
                administer your account, provide you access to the Services, and to contact you, including sending you
                notifications about the Services.
              </p>

              <p>
                When you access or use the Services, such as to create gatherings or events, create or respond to event
                invites, Bale will keep track of event details and attendance information.
              </p>

              <h2 className="font-subtitle">How Your Information Is Shared</h2>

              <p>
                The name you provide when you sign up for the Services may be shared with other users of the Services.
                Aggregated, anonymized data, may be provided with users of the Services.
              </p>

              <p>
                Additionally, any information you choose to share with other users and with us, such as information
                about gatherings or events, will be shared with users of the Services, and can be identified to your
                account.
              </p>

              <h2 className="font-subtitle">Data Retention</h2>

              <p>
                We will retain your information for as long as your account is active, as necessary to provide the
                Services, and to the extent necessary for complying with our legal obligations, and resolving disputes.
              </p>

              <p>
                We also collect and maintain aggregated, anonymized or pseudonymized information which we may retain
                indefinitely to improve our Services or comply with legal obligations.
              </p>

              <h2 className="font-subtitle">Securing Your Personal Information</h2>

              <p>
                We are continuously implementing and updating administrative, technical, and physical security measures
                to help protect your personal information against unauthorized access, destruction, or alteration.
                However, no method of transmission over the Internet, and no method of storing electronic information,
                can be 100% secure. We cannot guarantee the absolute security of your transmissions to us and of your
                personal information that we store.
              </p>

              <p>
                Your password protects your user account, so we encourage you to use a unique and strong password, limit
                access to your computer, browser, and mobile devices, and sign out of the Services when they are not in
                use.
              </p>

              <h2 className="font-subtitle">Your Rights</h2>

              <p>
                All users of the Services are provided the rights to access, correct, and request deletion of your
                personal information. All users may change any of their personal information at any time using the
                account settings, or by contacting us at by email at{" "}
                <a href={`mailto:${import.meta.env.VITE_SUPPORT_EMAIL}`}>{import.meta.env.VITE_SUPPORT_EMAIL}</a>.
              </p>

              <p>
                If you request, we will delete or anonymize your personal data so that it no longer identifies you. You
                may make this request by contacting us by email at{" "}
                <a href={`mailto:${import.meta.env.VITE_SUPPORT_EMAIL}`}>{import.meta.env.VITE_SUPPORT_EMAIL}</a>.
              </p>

              <p>
                If you would like to request a full report of all your personal information that we have collected, you
                make make this request by contacting us by email at{" "}
                <a href={`mailto:${import.meta.env.VITE_SUPPORT_EMAIL}`}>{import.meta.env.VITE_SUPPORT_EMAIL}</a>.
              </p>
            </article>
          </Card>
        </ContentFull>
      </ContentLayout>
    </FullScreenLayout>
  );
}
